/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import debounce from 'lodash.debounce';

import { useLocation } from "react-router-dom";

import * as Actions from "actions";
import {
  isShopSiteAndSubdomain,
  isMarketPlace,
  checkProductInCart,
  getLogo,
  isFeatureSupported,
  getURI, getPrice, analyticsTrackEvent
} from "helpers/utils";

import {
  TextField, InputAdornment, IconButton, Container, Typography, Chip, Box, Grid, Modal, Backdrop, Fade, Stack, Pagination,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import ShopProductItem from "components/elements/user/products/ShopProductItem";
import ShopProductDetail from "components/elements/user/products/ShopProductDetail";
import ShopProductDetailModal from "components/elements/user/products/ShopProductDetailModal";
import SearchIcon from "@mui/icons-material/Search";
import { Refresh } from "@mui/icons-material";
import SlideshowIcon from '@mui/icons-material/Slideshow';
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { H6 } from "components/CustomTypography";
import StoriesPlayer from "components/StoriesPlayer/StoriesPlayer";
import ShopProductCategorySlider from "components/elements/user/products/ShopProductCategorySlider";
import CustomSectionCreator from "components/CustomSectionCreator";
import CustomFlexBox from "components/CustomFlexBox";
import {Button} from "components/Atoms";
import UserProductStatusSelector from "components/elements/user/products/UserProductStatusSelector";
import ButtonComponent from "components/Button";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import * as ActionTypes from "constants/ActionTypes";

import UnifiedSwipeTrigger from "components/elements/main/UnifiedSwipeTrigger";
import { UnifiedLongPressableObject } from "components/elements/main/UnifiedLongPressableObject";
import UnifiedPullDown from "components/elements/main/UnifiedPullDown";
import UnifiedPullToRefresh from "components/elements/main/UnifiedPullToRefresh";

import CloseIcon from "@mui/icons-material/Close";
import MockSearchResults from "components/elements/main/MockSearchResults";
import {userResetProductDetail, userResetSearchProducts} from "actions";

const ShopProductSearch = (props) => {
  const [state, setState] = useState({
    limit: 20,
    hasMoreItems: true,
    breakPoint: "lg",
    bShowSearchModal: false,
    searchvalue: "Search products",
    isShop: true,
  });

  const [productState, setProductState] = useState("");
  const [productModeState, setProductModeState] = useState("PREVIEW");
  const [categoryState, setCategoryState] = useState("");
  const [colorState, setColorState] = useState("");
  const [optionValues, setOptionValues] = useState([]);

  const [sortState, setSortState] = useState("popular");
  const [currentPage, setCurrentPage] = useState(1);

  const [loadStoryState, setLoadStoryState] = useState(false);
  const [loadModalState, setLoadModalState] = useState(false);
  const [loadIdState, setLoadIdState] = useState("");
  const [currentStoryIndex, setCurrentStoryIndex] = useState(null);
  const [showModalProduct, setShowModalProduct] = useState(null);

  const [hasTriedLoading, setHasTriedLoading] = useState(false);

  const {
    isLoading,  isProdLoading, currency, addProductToCart, addProductToWishlist, addToCompare,
    userResetSearchProducts, userResetsearchKeywords,
    usersearchProducts, usersearchKeywords,
    usergetProductCategories,
    userGetProductInfo, userResetProductDetail,
    bootupInfo, reqProdStatus, serviceProdError,
    reqCartStatus, serviceCartError,
    products, productdetail, searchkeywords, match, history, symbol = "$",
    categoryList, colorList,
    cartItems, cartAddingPid, isCartLoading, cartList,
    shopId, isShop, limit, wholesale,
    userDetails, sendDataToParent, pagination
  } = props;

  const { keywords } = searchkeywords;
  const {
    resetvalue,
  } = state;

  const { query } = match.params;
  const { sort } = match.params;

  const urlparams = useLocation();

  const closeProductModal = () => setShowModalProduct(null);

  useEffect(() => {

    userResetSearchProducts();

    // Get a specific query parameter
    const checkLoadState = new URLSearchParams(urlparams.search).get('ls');

    if (checkLoadState) {
      if (checkLoadState === "1") {
        setLoadStoryState(true);
      } else if (checkLoadState === "2") {
        setLoadModalState(true);
      }
    }

    const loadIndex = new URLSearchParams(urlparams.search).get('li');

    if (loadIndex) {
      setLoadIdState(loadIndex);
    }

    if (sort) {
      setSortState(sort);
    }

    // Do NOT reset previous results as Reels gets affected

    if (query) {
      setHasTriedLoading(false);
      usersearchProducts(query, shopId, isShop, isShopSiteAndSubdomain(), "", sort, 1);
    } else {
      setHasTriedLoading(false);
      usergetProductCategories(shopId, isShop, isShopSiteAndSubdomain());
      // load with default category
      usersearchProducts("", shopId, isShop, isShopSiteAndSubdomain(), "", sort, 1);
    }
  }, []);

  const handleRefresh = () => {
    setHasTriedLoading(false);
    if (query) {
      usersearchProducts(query, shopId, isShop, isShopSiteAndSubdomain(), categoryState, sortState, currentPage);
    } else {
      usergetProductCategories(shopId, isShop, isShopSiteAndSubdomain());
      usersearchProducts("", shopId, isShop, isShopSiteAndSubdomain(), categoryState, sortState, currentPage);
    }
  };

  useEffect(() => {
    switch (reqCartStatus) {
      case ActionTypes.USER_ADD_PRODUCT_TO_WISHLIST_SUCCESS:
        usersearchProducts("", shopId, isShop, isShopSiteAndSubdomain(), "", sortState, currentPage);
        setProductModeState("PREVIEW");
        break;
      default:
        break;
    }
  }, [serviceCartError, reqCartStatus]);

  useEffect(() => {
    if (!isLoading && products.length > 0 && loadStoryState) {
      openStoriesView();
      setLoadStoryState(false);
    }
  }, [isLoading, products, loadStoryState]);

  useEffect(() => {
    if (
        loadModalState &&
        products.length > 0 &&
        loadIdState !== "" &&
        products[loadIdState]
    ) {
      openModalView();
      setLoadModalState(false);
    }
  }, [loadModalState, products, loadIdState]);


  useEffect(() => {
    if (!isLoading) {
      setHasTriedLoading(true);
    }
  }, [isLoading]);


  useEffect(() => {
    switch (reqProdStatus) {
      case ActionTypes.USER_GET_PRODUCT_INFO_SUCCESS:
        // update fav icon to show status
        break;
      default:
        break;
    }
  }, [serviceProdError, reqProdStatus]);


  const runSearch = (keyword) => {
    userResetsearchKeywords();
    setState({ searchquery: keyword });
    setState({ resetvalue: "" });

    if (isShopSiteAndSubdomain()) {
      history.push(`/products/search/${keyword}`);
    } else {
      history.push(`/shop/${shopId}/products/search/${keyword}`);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      runSearch(e.target.value);
    }
  };

  const setKeyword = (option, type) => {
    if (type === "selectOption") {
      runSearch(option.target.innerText);
    }
  };

  const runKeywordSearch = (value) => {
    setState({ resetvalue: value });
    if ((value.length > 1)) {
      usersearchKeywords(value, isShopSiteAndSubdomain() ? bootupInfo.appState.subdomain_shopId : shopId, isShop, isShopSiteAndSubdomain(), limit);
    }
  };

  const onCancel = () => {
    closeProductModal();
    //history.go(0);
  }
  const debouncedChangeHandler = useCallback(
      debounce(runKeywordSearch, 300)
      , []);

  const selectKeywordSearch = (value) => {
    if (isShopSiteAndSubdomain()) {
      history.push(`/products/search/${value}`);
    } else {
      history.push(`/shop/${shopId}/products/search/${value}`);
    }
  };

  const handleDelete = () => {
    if (isShopSiteAndSubdomain()) {
      history.push("/products");
  } else {
      history.push(`/shop/${shopId}/products`);
    }
  };

  const handleBuyProduct = (product, index) => {

    userGetProductInfo(product.product_id);
    setProductState({
      selectedProduct: {
        _id: product._id,
        product_id: product.product_id,
        shop_id: product.shop_id,
        status: product.status,
        images: product.images,
        video: product.video,
        title: product.title,
        logo: product.logo,
        area: product.area,
        price: product.price,
        is_price_visible: product.is_price_visible,
        is_price_onunlock: product.is_price_onunlock,

      },
    });

    // Open modal instead of changing view mode
    setShowModalProduct(product);
  };


  const handleAddProductToWishlist = (prodId) => {
    addProductToWishlist(prodId);
  };

  const handleProductView = (mode, product, index, withStory, reset) => () => {

    if (withStory) {
      setLoadIdState(index);
    }

    if (reset) {
      setProductState({
        selectedProduct: {
          _id: "",
          product_id: "",
          shop_id: "",
          status: "",
          images: [],
          video: [],
          title: "",
          logo: [],
          area: "",
          price: "",
          is_price_visible: "",
          is_price_onunlock: ""
        },
      });
      setProductModeState(mode);
    } else {

      analyticsTrackEvent("User Interaction", "Shop Product Clicked : Story - " + withStory, product.title + " " + product.shop_id + " " + product.product_id);

      userGetProductInfo(product.product_id);

      setProductState({
        selectedProduct: {
          _id: product._id,
          product_id: product.product_id,
          shop_id: product.shop_id,
          status: product.status,
          images: product.images,
          video: product.video,
          title: product.title,
          logo: product.logo,
          area: product.area,
          price: product.price,
          is_price_visible: product.is_price_visible,
          is_price_onunlock: product.is_price_onunlock,

        },
      });

      // Open modal for VIEWDETAIL mode, otherwise set product mode state
      if (mode === "VIEWDETAIL") {
          setShowModalProduct(product);
      } else {
          setProductModeState(mode);
      }
    }
  };

  const handleSelectCategorySet = (category) => {
    setCurrentPage(1);
    setCategoryState(category);
    setHasTriedLoading(false);
    usersearchProducts("", shopId, isShop, isShopSiteAndSubdomain(), category, sort, 1);
  };

  const openStoriesView = () => {
    setProductModeState("STORIES");
  };

  const openModalView = () => {
    handleModalView(products[loadIdState], loadIdState)();
    setProductModeState("PREVIEW");
  };

  useEffect(() => {
    setOptionValues(keywords);
  }, [keywords]);


  const setProductStatus = (sort) => {
    setCurrentPage(1);
    setSortState(sort);
    setHasTriedLoading(false);
    usersearchProducts("", shopId, isShop, isShopSiteAndSubdomain(), "", sort, 1);
  };

  const handleRestAll = () => {
    setCurrentPage(1);
    setSortState("");
    setCategoryState("");
    setHasTriedLoading(false);
    usersearchProducts("", shopId, isShop, isShopSiteAndSubdomain(), "", sort, 1);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    setHasTriedLoading(false);
    if (query) {
      usersearchProducts(query, shopId, isShop, isShopSiteAndSubdomain(), categoryState, sortState, value);
    } else {
      usersearchProducts("", shopId, isShop, isShopSiteAndSubdomain(), categoryState, sortState, value);
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleResetResultsStory = () => {
    setProductModeState("PREVIEW");
    setLoadIdState("");
  };

  const handleResetProductStory = () => {
    setLoadIdState("");
  };

  const MobileViewOnClick = () => {
    if (window.innerWidth <= 500 && (match.path !== "/products/search" || match.path !== "/shop/:shopId/products/search")) {
      history.push(isShopSiteAndSubdomain() ?  "/products/search" : `/shop/${shopId}/products/search`);
    }
  };

  let isModalSearch = false;

  const renderNoResults = () => (
      <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '20px',
          }}
      >
        <ButtonComponent
            type="primary"
            variant="outlined"
            name="Reset"
            size="medium"
            onClick={handleRestAll}
        />
      </Box>
  );

  var type = {
    'new': 'Latest Products',
    'popular': 'Popular Products',
    'default': 'Popular Products'
  };

  const handleModalView = (product, index) => () => {

    userResetProductDetail();

    setShowModalProduct(product);

    userGetProductInfo(product.product_id);

    setProductState({
      selectedProduct: {
        _id: product._id,
        product_id: product.product_id,
        shop_id: product.shop_id,
        status: product.status,
        images: product.images,
        video: product.video,
        title: product.title,
        logo: product.logo,
        area: product.area,
        price: product.price,
        is_price_visible: product.is_price_visible,
        is_price_onunlock: product.is_price_onunlock,

      },
    });

  }

  const renderResults = () => (
      <div>
        {/*isFeatureSupported("shopreels") &&
            <CustomFlexBox sx={{
              display: 'flex',
              flexDirection: 'row',
              position: 'fixed',
              width: '100%',
              bottom: 70,
              justifyContent: 'center',
              zIndex: 'modal'
            }}>
              <Button
                  sx={{marginRight: '2px'}}
                  size="large"
                  color="primary"
                  variant="contained"
                  onClick={openStoriesView}
              >
                <SlideshowIcon /> Open {process.env.REACT_APP_REELS_TAG}
              </Button>
            </CustomFlexBox>
        */}
      <Grid item container xs={12} sm={12} md={12} lg={12} spacing={2}>
        {products.map((product, index) => (
            <Grid item key={index} xs={6} sm={3} md={3} lg={3}>
              <UnifiedLongPressableObject item={product} index={index}
                                          onLongPress={handleModalView(product, index)}>
                <ShopProductItem
                    product={product}
                    symbol={currency}
                    inCart={checkProductInCart(cartItems, product.product_id)}
                    isCartLoading={isCartLoading}
                    cartAddingPid={cartAddingPid}
                    shopId={shopId}
                    onAddToWishlistClicked={() => handleAddProductToWishlist(product.product_id)}
                    onAddToCartClicked={() => addProductToCart(product.product_id, isMarketPlace() ? shopId : bootupInfo.appState.subdomain_shopId, !isMarketPlace())}
                    onMainClick={handleModalView(product, index)}
                    onArrowClick={handleProductView("STORIES", product, index, true, false)}
                    onBottomClick={handleModalView(product, index)}
                    /* viewProductWithStory={handleProductView("STORIES", product, index, true, false)}
                    viewProduct={handleProductView("VIEWDETAIL", product, index, false, false)} */
                    key={`${index + 1}`}
                />
              </UnifiedLongPressableObject>
            </Grid>
        ))}
      </Grid>
      </div>
  );

  const storiesData = products.map((product, index) => {
    const {id, product_id, images, video, name, title, area } = product;

    let stories = [];

    if (video && video.length > 0) {
      let videoimage = (images && images.length > 0) ? (images[0].full_size_cdn && images[0].full_size_cdn.secure_url ? images[0].full_size_cdn.secure_url : images[0].cdn.secure_url) : "";
      stories.push({
        video: video[0].cdn.secure_url,
        videoimage: videoimage
      });
    } else {
      images && images.map((image) => (
          stories.push({
            image: image.full_size_cdn && image.full_size_cdn.secure_url ? image.full_size_cdn.secure_url : image.cdn.secure_url,
          })
      ));
    }


    return (
        {
          user: {
            avatar : "",
            name: getPrice(product, currency),
            linkTitle2: "Detail",
            area: "",
          },
          item: product,
          itemIndex: index,
          favId: product_id,
          stories: stories,
        }
    );
  });

  const renderResultsAsStories = () => (
      <div>
        <StoriesPlayer
            loadIndex={loadIdState}
            storiesData={storiesData}
            setAsFav={handleAddProductToWishlist}
            onButton2Click={handleBuyProduct}
            onIndexChange={(index) => setCurrentStoryIndex(index)}
            onCancel={() => handleResetResultsStory()}
        />
        <UnifiedSwipeTrigger
            onLeftSwipeComplete={() => setProductModeState("PREVIEW")}
            onRightSwipeComplete={() => handleBuyProduct(products[currentStoryIndex], currentStoryIndex)}
        />
      </div>
  );


  const renderProductDetail = () => (

      <>
        <ShopProductDetail
            {...props}
            setState={(value, field) => setProductState({
              ...state,
              selectedProduct: {
                ...selectedProduct,
                [field]: value,
              },
            })}
            shopId={shopId}
            currency={currency}
            bootupInfo={bootupInfo}
            userDetails={userDetails}
            cartItems={cartItems}
            isLoading={isLoading}
            isCartLoading={isCartLoading}
            cartAddingPid={cartAddingPid}
            productdetail={productdetail}
            selectedProduct={selectedProduct}
            onAddToWishlistClicked={() => handleAddProductToWishlist(productdetail.product_id)}
            onAddToCartClicked={() => addProductToCart(productdetail.product_id, isMarketPlace() ? shopId : bootupInfo.appState.subdomain_shopId, !isMarketPlace())}
            history={history}
            onCancel={() => setProductModeState("PREVIEW")}
        />
        <UnifiedSwipeTrigger
            onLeftSwipeComplete={() => setProductModeState("PREVIEW")}
        />
      </>
  );

  const renderProductModal = () => (

      <>
        <ShopProductDetailModal
            {...props}
            setState={(value, field) => setProductState({
              ...state,
              selectedProduct: {
                ...selectedProduct,
                [field]: value,
              },
            })}
            currency={currency}
            bootupInfo={bootupInfo}
            userDetails={userDetails}
            cartItems={cartItems}
            isLoading={isLoading}
            isCartLoading={isCartLoading}
            cartAddingPid={cartAddingPid}
            productdetail={productdetail}
            selectedProduct={selectedProduct}
            onAddToWishlistClicked={() => handleAddProductToWishlist(productdetail.product_id)}
            onAddToCartClicked={() => addProductToCart(productdetail.product_id, isMarketPlace() ? shopId : bootupInfo.appState.subdomain_shopId, !isMarketPlace())}
            history={history}
            onCancel={onCancel}
        />
      </>
  );

  const renderProductWithStoriesPlayer = (productData) => (

      <div>

        {renderProductDetail()}

        <StoriesPlayer
            storiesData={productData}
            onCancel={() => handleResetProductStory()}
            setAsFav={handleAddProductToWishlist}
        />
      </div>

  );

  const renderSearchHelp = () => (
      <Container>
        <Box>
          {
            window.innerWidth <= 500
            && (match.path === "/products/search" || match.path === "/shop/:shopId/products/search")
            && optionValues.map((element) => (
                <Container>
                  <Typography onClick={() => history.push(`search/${element.label}`)}>
                    <IconButton disabled size="large">
                      <SearchIcon />
                    </IconButton>
                    {element.label}
                  </Typography>
                </Container>
            ))
          }
        </Box>
      </Container>
  );

  const renderSearchModule = () => (
    <>

      {/* <Container onClick={MobileViewOnClick}>
          <Box mb={2}>
        {
            window.innerWidth <= 500
            && (match.path === "/products/search" || match.path === "/shop/:shopId/products/search" ) ? isModalSearch = true : isModalSearch = false
          }
        <Autocomplete
          id="autocomplete"
          onClose={setKeyword}
          disableClearable
          freeSolo
          inputValue={resetvalue}
          onOpen={() => setState({ selected: false })}
          value={resetvalue}
          onKeyPress={handleKeyPress}
          onSelect={(input) => debouncedChangeHandler(input.target.value)}
          options={window.innerWidth <= 500 ? [] : optionValues.map((element) => element.label)}
          renderInput={(params) => (
            <TextField
                {...params}
              InputProps={{
                sx: {
                  height: 44,
                  paddingRight: 0,
                  borderRadius: 0,
                  color: "grey.900",
                  overflow: "hidden",
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "primary.main",
                  },
                },
                startAdornment: <SearchOutlinedIcon fontSize="small" />,
              }}
              autoFocus={isModalSearch}
              placeholder={`Search ${process.env.REACT_APP_PRODUCT_TITLE}`}
            />
          )}
        />
        </Box>
      </Container>

      {
        renderSearchHelp()
          }
          */}

      <Container>
        {query && (
        <Chip
          label={query}
          onDelete={handleDelete}
        />
        )}
      </Container>

      { /* match.path !== "/product"
      && */ match.path !== "/"
      && (
          match.path === "/products" ||     /* for user site */
          match.path === "/products/search/:query" ||
          match.path === "/products/sort/:sort" ||
          match.path === "/shop/:shopId/products" ||    /* marketplace */
          match.path === "/shop/:shopId/products/search/:query" ||
          match.path === "/shop/:shopId/products/sort/:sort"
      ) && (
      <>
        { !query &&
            <ShopProductCategorySlider
                categoryList={categoryList}
                selectedCategory={categoryState}
                handleSelectCategoryLink={handleSelectCategorySet}
                handleSelectCategorySet={handleSelectCategorySet}

            />
        }
        {/* !query && (<CustomSectionCreator title={type[sort] || type['default']}  />) */}
        {query ? (<CustomSectionCreator title={"Searching: '" + query + "'"} />) : (<CustomFlexBox bgcolor="#fff" justifyContent="space-between" alignItems="center" p={1} />)}

        <CustomFlexBox alignItems="center" mt={2} mb={2} sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
        }}>
          <Box width="45%">
            <UserProductStatusSelector
                onStatusSelect={setProductStatus}
                productstatus={sortState}
            />
          </Box>
          <Box width="25%">
            <ButtonComponent
                type="primary"
                variant="outlined"
                name="View All"
                size="medium"
                onClick={handleRestAll}>
            </ButtonComponent>
          </Box>
          <Box width="30%">
          </Box>
        </CustomFlexBox>

        {isProdLoading ? (
            <MockSearchResults />
        ) : products.length > 0 ? (
            renderResults()
        ) : hasTriedLoading ? (
            renderNoResults()
        ) : null}

        <CustomFlexBox alignItems="center" mb={4} sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
        }}>
          {/* Pagination */}
          {!isProdLoading && products.length > 0 && pagination && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, mb: 2, width: '100%' }}>
              <Stack spacing={2}>
                <Pagination
                  count={pagination.totalPages}
                  page={currentPage}
                  onChange={handlePageChange}
                  color="primary"
                  size="large"
                />
              </Stack>
            </Box>
          )}
        </CustomFlexBox>

      </>
      )}
    </>
  );

  const renderProductMode = (productMode) => {

    sendDataToParent(productMode);

    switch (productMode) {

      case "STORIES":
        return renderResultsAsStories();

      case "STORIESVIEW":

        const {id, shop_id, product_id, images, video, title, area } = selectedProduct;

        let productStoryData = [];
        let stories = [];

        if (video && video.length > 0) {
          let videoimage = (images && images.length > 0) ? (images[0].full_size_cdn && images[0].full_size_cdn.secure_url ? images[0].full_size_cdn.secure_url : images[0].cdn.secure_url) : "";
          stories.push({
            video: video[0].cdn.secure_url,
            videoimage: videoimage
          });
        } else {
          images && images.map((image) => (
              stories.push({
                image: image.full_size_cdn && image.full_size_cdn.secure_url ? image.full_size_cdn.secure_url : image.cdn.secure_url
              })
          ));
        }


        productStoryData.push(
            {
              user: {
                avatar: "",
                name: getPrice(selectedProduct, currency),
                linkTitle2: "Detail",
                area: "",
              },
              item: selectedProduct,
              favId: product_id,
              stories: stories,
            }
        );

        return renderProductWithStoriesPlayer(productStoryData);

      case "VIEWDETAIL":
        return renderProductDetail();

      case "PREVIEW":
      default:
        return renderSearchModule();
    }
  };

  const handlePage = (page) => (e) => {
    history.push(page);
  };

  const { selectedProduct = {} } = productState;
  const { records } = products;
  const { categories } = categoryList;
  const { selectedCategory = {} } = categoryState;

  return (
      <Container>
        {productModeState === "PREVIEW" ? (
          <UnifiedPullToRefresh
            onRefresh={handleRefresh}
            isRefreshing={isProdLoading}
          >
            {renderProductMode(productModeState)}
          </UnifiedPullToRefresh>
        ) : (
          renderProductMode(productModeState)
        )}

        <Modal
            open={!!showModalProduct}
            onClose={closeProductModal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{ timeout: 300 }}
        >
          <Fade in={!!showModalProduct}>
            <Box>
              <IconButton
                  onClick={closeProductModal}
                  sx={{
                    position: 'absolute',
                    top: '2%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 1301,
                    backgroundColor: 'black',
                    color: 'white',
                    width: 48,
                    height: 48,
                    pointerEvents: 'auto',
                    '&:hover': {
                      backgroundColor: 'grey.800',
                    },
                  }}
              >
                <CloseIcon />
              </IconButton>
              <Box
                  sx={{
                    position: 'absolute',
                    top: '8%',
                    height: '95%',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
              >
                {/* checking showModalProduct.product_id === selectedProduct.product_id avoids race condition */}
                {showModalProduct && selectedProduct && showModalProduct.product_id === selectedProduct.product_id && (
                    <>
                      <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '96%',
                        height: '95%',
                        overflow: 'auto',
                        boxSizing: 'border-box',
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 2,
                      }}>
                        <UnifiedPullDown onPullDown={closeProductModal} threshold={60}>
                        {renderProductModal()}
                        </UnifiedPullDown>
                      </Box>
                      <UnifiedSwipeTrigger
                          onLeftSwipeComplete={() => { closeProductModal(); setProductModeState("PREVIEW"); }}
                          onRightSwipeComplete={() => { closeProductModal(); history.push(getURI(process.env.REACT_APP_TYPE, "shop_home", selectedProduct.shop_id, "", "")); }}
                      />
                    </>
                )}
              </Box>
            </Box>
          </Fade>
        </Modal>

      </Container>
  );

};

ShopProductSearch.defaultProps = {
  currency: "",
};

ShopProductSearch.propTypes = {
  currency: PropTypes.string,
  addProductToCart: PropTypes.func.isRequired,
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  pagination: PropTypes.object,
  categoryList: PropTypes.arrayOf(PropTypes.object),
  colorList: PropTypes.arrayOf(PropTypes.object),
  bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
  searchkeywords: PropTypes.objectOf(PropTypes.any).isRequired,
  addProductToWishlist: PropTypes.func.isRequired,
  addToCompare: PropTypes.func.isRequired,
  usersearchProducts: PropTypes.func.isRequired,
  usersearchKeywords: PropTypes.func.isRequired,
  userResetsearchKeywords: PropTypes.func.isRequired,
  userResetSearchProducts: PropTypes.func.isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
};

// Mapping Props and State.
const ShopProductSearchComponent = connect(
  ({ userproducts, cartList, bootupInfo, userbootupInfo }) => ({
    bootupInfo,
    userbootupInfo,
    userDetails: bootupInfo.userDetails,
    currency: bootupInfo.symbol,
    reqProdStatus: userproducts.reqStatus,
    isProdLoading: userproducts.isLoading,
    serviceProdError: userproducts.serviceError,
    products: userproducts.searchproducts,
    pagination: userproducts.pagination,
    productdetail: userproducts.productdetail,
    cartItems: cartList.cart,
    isCartLoading: cartList.isLoading,
    cartAddingPid: cartList.cartAddingPid,
    reqCartStatus: cartList.reqStatus,
    serviceCartError: cartList.serviceError,
    searchkeywords: userproducts.searchkeywords,
    categoryList: userproducts.categoryList,
    colorList: userproducts.colorList,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(ShopProductSearch);

export { ShopProductSearchComponent as default };
